import { LineItemsApi, type LineItem } from './lineItemsApi'

/**
 * Line items whose name or references contain the term, led by the one whose
 * id it is. Ids are not text columns the list search can match, so a term that
 * could be an id is also looked up as one.
 */
export async function searchLineItems(term: string): Promise<LineItem[]> {
  const text = term.trim()
  const [byId, byName] = await Promise.all([
    text && !/\s/.test(text) ? LineItemsApi.getByIds([text]).catch(() => []) : [],
    LineItemsApi.getAll({ search: text, objectState: 'all' }),
  ])
  return [...byId, ...byName.filter((lineItem) => !byId.some((match) => match.id === lineItem.id))]
}
